import React from 'react';
import ThemeStore from "../../services/config/ThemeStore";

import {observer} from 'mobx-react';
import {ThemeEditor} from "./ThemeEditor";

/**
 * This is just a wrapper of the Theme Editor for the BrandSettings page in myAccount
 */
@observer
export class BrandSettings extends React.Component {
  render() {
    const isPreviewMode = ThemeStore.isPreviewMode;

    return (
      <React.Fragment>
        { !isPreviewMode && <ThemeEditor/>}
        { isPreviewMode &&
          <div className="d-flex align-self-center justify-content-center h-100">
            <button className="btn btn-secondary d-flex align-self-center" onClick={() => {
              ThemeStore.setPreviewMode(!ThemeStore.isPreviewMode)
            }}>Exit Preview Mode</button>
          </div>
        }
      </React.Fragment>
    );
  }
}
